
import _ from 'lodash';
import { getApiMethod } from '@/modules/apiSelector';
import store from '@/store';
import logger from '@/modules/Logger';

export default {
  methods: {
    async executeUpdateChatMessage(params) {
      const apiMethod = getApiMethod('updateChatMessage');
      let returnData = null;
      await apiMethod(params, (data) => {
        logger.info('Update chat message history', {
          operation: 'chat-history:update-message',
          payload: params,
          response: data
        });

        returnData = _.merge(data, params);

        store.commit('chatHistory/updateChatMessageInfo', returnData);
      });

      return returnData;
    },
    async executeDeleteChatMessage(params) {
      const apiMethod = getApiMethod('deleteChatMessage');
      await apiMethod(params, (data) => {
        logger.info('Delete chat message history', {
          operation: 'chat-history:delete-message',
          payload: params,
          response: data
        });

        store.commit('chatHistory/deleteChatMessageInfo', data);
      });
    },
    async fetchChatEditsHistory(params) {
      const apiMethod = getApiMethod('getChatHistory');
      let response = null;
      try {
        const { result, data, errMessage } = await apiMethod(params, true, (data) => {
          logger.info('Loading chat message edit history', {
            operation: 'chat-edits-history:module-load',
            payload: params
          });

          store.commit('chatHistory/setChatEditsHistoryInfo', data);
        });

        response = result ? data : errMessage;
      } catch (error) {
        logger.error('Failed to retrieve chat message edit history', error);
        response = error.message;
      }

      return response;
    },
  }
};
